import React from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';

import asyncComponent from '../../../util/asyncComponent';


const Setting = ({match}) => (
    <div className="app-wrapper">
        <Switch>
            <Redirect exact from={`${match.url}/`} to={`${match.url}/alert`}/>
            <Route path={`${match.url}/alert`} component={asyncComponent(() => import('./routes/Alert'))}/>
            <Route path={`${match.url}/alert-group`} component={asyncComponent(() => import('./routes/AlertGroup'))}/>
            <Route path={`${match.url}/alert-tracking`} component={asyncComponent(() => import('./routes/AlertTracking'))}/>
            <Route path={`${match.url}/broadcast-message`} component={asyncComponent(() => import('./routes/BroadcastMessage'))}/>
            <Route path={`${match.url}/config-parameter`} component={asyncComponent(() => import('./routes/ConfigParameter'))}/>
            <Route path={`${match.url}/dispatch-score`} component={asyncComponent(() => import('./routes/DispatchScore'))}/>
            <Route path={`${match.url}/email-list`} component={asyncComponent(() => import('./routes/EmailList'))}/>
            <Route path={`${match.url}/kpi-driver-score`} component={asyncComponent(() => import('./routes/KpiDriverScore'))}/>
            <Route path={`${match.url}/map-alert`} component={asyncComponent(() => import('./routes/MapAlert'))}/>
            <Route path={`${match.url}/parameter-company`} component={asyncComponent(() => import('./routes/ParameterCompany'))}/>
            <Route path={`${match.url}/parameter-vehicle`} component={asyncComponent(() => import('./routes/ParameterVehicle'))}/>
            <Route path={`${match.url}/parameter-vehicle-type`} component={asyncComponent(() => import('./routes/ParameterVehicleType'))}/>
            <Route path={`${match.url}/sms-list`} component={asyncComponent(() => import('./routes/SmsList'))}/>
            <Route path={`${match.url}/target-performance`} component={asyncComponent(() => import('./routes/TargetPerformance'))}/>
            <Route component={asyncComponent(() => import('components/Error404'))}/>
        </Switch>
    </div>
);

export default Setting;


// WEBPACK FOOTER //
// ./app/routes/Setting/index.js